import { Text } from '@/theme/index';

interface CustomEmptySectionTextProps {
  title: string;
}

export const EmptyVehicleSectionDisclaimer = ({
  title,
}: CustomEmptySectionTextProps) => {
  const customText = `No ${title} records found. Please note that the absence of any information or results within our reports may not necessarily be 100% accurate, complete, or up to date, so please do not use it in lieu of your own due diligence.`;

  return <Text color="text.secondary">{customText}</Text>;
};
